/**
 * Локальный черновик конструктора найма (без авторизации).
 * Вынесен в отдельный ключ, чтобы не путать с contract_backup / pending_contract_data.
 */
export const GUEST_RENT_DRAFT_STORAGE_KEY = 'docgen_rent_guest_draft_v1';

/**
 * @returns {{ templateId: string, data: object, updatedAt?: string } | null}
 */
export function readGuestRentDraft() {
    try {
        const raw = localStorage.getItem(GUEST_RENT_DRAFT_STORAGE_KEY);
        if (!raw) return null;
        const parsed = JSON.parse(raw);
        if (!parsed || typeof parsed !== 'object' || !parsed.data || typeof parsed.data !== 'object') {
            return null;
        }
        return parsed;
    } catch {
        return null;
    }
}

export function writeGuestRentDraft({ templateId, data }) {
    try {
        localStorage.setItem(
            GUEST_RENT_DRAFT_STORAGE_KEY,
            JSON.stringify({
                templateId,
                data,
                updatedAt: new Date().toISOString()
            })
        );
    } catch (e) {
        console.warn('guestRentDraft: не удалось сохранить черновик', e);
    }
}

export function clearGuestRentDraft() {
    try {
        localStorage.removeItem(GUEST_RENT_DRAFT_STORAGE_KEY);
    } catch (e) {
        console.warn('guestRentDraft: не удалось очистить черновик', e);
    }
}
